import type {
  ShopSettingResponse,
  ShopSettingsCategory,
  ShopSettingsPayload
} from '@/api/types/shop';
import type { GuideStep } from '@/atom/shop-info';
import clientV2 from '@/lib/request-v2';
import client from '../lib/request';

export default {
  getShopData(param = {}) {
    return client.post('admin/getShopData', param);
  },
  getCheckoutId() {
    return clientV2.get('/shop/checkout-profile');
  },
  getPrivacyKey() {
    return clientV2.get<{ secret_token: string }>('/shop/privacy-key');
  },
  getShopSetting(category: ShopSettingsCategory) {
    return clientV2.get<ShopSettingResponse>('/shop/setting', {
      params: { category }
    });
  },
  updatedShopSetting(param: ShopSettingsPayload) {
    return clientV2.put('/shop/setting', param);
  },
  updatedShopStarFeedback(param: { star_feedback_at: string }) {
    return clientV2.put('/shop/star-feedback', param);
  },
  updatedShopGuideStep(param: { finished_steps: GuideStep }) {
    return clientV2.put('/shop/guide/steps', param);
  },
  reportError(param: any) {
    return client.post('/dataReport', param);
  }
};
